import { FC } from "react";
import { IconPropsType } from ".";

export const Remove: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5.5L3.95288 14.5523C3.97966 14.8068 4.19425 15 4.45013 15H11.5499C11.8057 15 12.0203 14.8068 12.0471 14.5523L13 5.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.5 5.5V12M9.5 5.5V12"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 3H6M13 3H10M6 3V1.5C6 1.22386 6.22386 1 6.5 1H8H9.5C9.77614 1 10 1.22386 10 1.5V3M6 3H10"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
